module.exports = __webpack_public_path__ + "img/ic_64_achievement_siegesserie.26d6c740.svg";